import { useEffect, useState } from 'react'
import { useErrorPopupStore } from '../../store/useErrorPopupStore'
import {
  DEFAULT_SERVICE_RM,
  fetchCurrentServiceRm,
  openWhatsAppChat,
} from '../../utils/relationshipManager'
import FullPagePopupLayout from './FullPagePopupLayout'

export function ErrorPopup() {
  const { isOpen, description, onClose, hideErrorPopup } = useErrorPopupStore()
  const [serviceRm, setServiceRm] = useState(DEFAULT_SERVICE_RM)

  useEffect(() => {
    if (!isOpen) return undefined

    let isMounted = true

    fetchCurrentServiceRm()
      .then((rm) => {
        if (isMounted && rm) {
          setServiceRm(rm)
        }
      })
      .catch(() => {
        if (isMounted) {
          setServiceRm(DEFAULT_SERVICE_RM)
        }
      })

    return () => {
      isMounted = false
    }
  }, [isOpen])

  const handleClose = () => {
    hideErrorPopup()
    if (onClose) onClose()
  }

  const serviceRmPhone = serviceRm?.phone || DEFAULT_SERVICE_RM.phone
  const serviceRmDialPhone = serviceRmPhone.replace(/\s+/g, '')

  const handleCallServiceRm = () => {
    if (serviceRmDialPhone) {
      window.location.href = `tel:${serviceRmDialPhone}`
    }
  }

  const handleMessageServiceRm = () => {
    openWhatsAppChat(serviceRmPhone)
  }

  return (
    <FullPagePopupLayout
      isOpen={isOpen}
      onClose={handleClose}
      severity='error'
      title="We're sorry"
      message={description}
      bodyClassName='fabits-error-popup-body'
      actionsClassName='fabits-global-popup-actions-single'
      contentClassName='fabits-error-popup'
      actions={
        <button
          type='button'
          className='fabits-global-popup-button fabits-global-popup-button-primary'
          onClick={handleClose}
        >
          Close
        </button>
      }
    >
      <div className='fabits-error-popup-support'>
        <p className='fabits-error-popup-support-copy'>
          Need help? Please contact {serviceRm?.name || DEFAULT_SERVICE_RM.name}, your service RM.
        </p>
        <p className='fabits-error-popup-support-phone'>{serviceRmPhone}</p>
        <div className='fabits-error-popup-contact-actions'>
          <button
            type='button'
            className='fabits-error-popup-contact-button fabits-error-popup-contact-button-secondary'
            onClick={handleCallServiceRm}
          >
            Call
          </button>
          <button
            type='button'
            className='fabits-error-popup-contact-button fabits-error-popup-contact-button-primary'
            onClick={handleMessageServiceRm}
          >
            Message
          </button>
        </div>
      </div>
    </FullPagePopupLayout>
  )
}
